import { render, staticRenderFns } from "./CreatePostdetail.vue?vue&type=template&id=7a4402c5&"
import script from "./CreatePostdetail.vue?vue&type=script&lang=js&"
export * from "./CreatePostdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports